<script>
export default {
  name: 'CancelSubscription',
  props: {
    expire: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      note: null,
      loading: false
    }
  },
  mounted() {
    this.loading = false
  },
  methods: {
    async confirm() {
      this.loading = true
      this.$emit('confirm', this.note)
    }
  }
}
</script>

<template>
  <div class="subscription-modal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Cancel subscription
        </p>
      </header>
      <section class="modal-card-body">
        <div class="content">
          If you cancel now, you won’t be charged another yearly subscription.
          You can still access all features until
          <time :datetime="expire">{{ expire }}</time>
        </div>
        <b-field
          label="Please tell us why you are unsubscribing"
          custom-class="has-text-primary"
        >
          <b-input
            v-model="note"
            minlength="1"
            maxlength="200"
            type="textarea"
            rows="2"
            :has-counter="false"
            required
          />
        </b-field>
      </section>
      <footer class="modal-card-footer">
        <footer class="modal-card-foot">
          <b-button
            type="is-warning"
            :disabled="!note"
            :loading="loading"
            rounded
            @click="confirm"
          >
            Cancel subscription
          </b-button>
          <button
            class="button is-tertiary is-rounded"
            type="button"
            :disabled="loading"
            @click="$parent.close()"
          >
            Not now
          </button>
        </footer>
      </footer>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.content
  margin-bottom: 12px
</style>
